import type { Database } from 'sql.js';
import { publicFileUrl, queryAll, queryOne } from '@core/infrastructure/driven/sqljs/sqljsSqlitePrimitives.ts';
import type { PuntoEntregaDetail } from '../../../domain/puntoEntregaModel.ts';
import { isPuntoEntregaLugarOrigen } from '../../../domain/puntoEntregaLugarOrigen.ts';
import { mapPepToForm } from './mappers.ts';
import { PUNTO_ENTREGA_LOCATION_FROM_SQL } from './puntoEntregaLocationFromSql.ts';

export function getPuntoEntregaDetail(
  db: Database,
  filesPublicPrefix: string,
  id: number,
): PuntoEntregaDetail | null {
  const head = queryOne(
    db,
    `SELECT pe.id, pe.public_id, pe.entrega_id, pe.es_remanente, pe.lugar_id, pe.lugar_origen,
              pe.fecha_hora, pe.latitud, pe.longitud, pe.direccion, pe.responsable_id AS responsable_id, pe.informe_pdf,
              pe.offline_uploaded_at,
              u.nombre AS responsable_nombre,
              COALESCE(b.id, 0) AS barrio_id,
              COALESCE(pec.comuna_id, b.comuna_id) AS comuna_id
       ${PUNTO_ENTREGA_LOCATION_FROM_SQL}
       LEFT JOIN usuarios u ON u.id = pe.responsable_id
       WHERE pe.id = ?`,
    [id],
  );
  if (!head) return null;

  const peps = queryAll(
    db,
    `SELECT pep.* FROM punto_entrega_participante pep
     WHERE pep.punto_entrega_id = ? ORDER BY pep.id`,
    [id],
  );

  const participantes = peps.map((pep) => mapPepToForm(db, filesPublicPrefix, pep));

  const offlineRaw = head.offline_uploaded_at ?? head.OFFLINE_UPLOADED_AT;
  const offlineStr = offlineRaw != null && offlineRaw !== '' ? String(offlineRaw).trim() : '';
  const offlineUploadedAt = offlineStr.length > 0 ? offlineStr : null;

  const lugarOrigenRaw = String(head.lugar_origen ?? 'legacy');
  const lugarOrigen = isPuntoEntregaLugarOrigen(lugarOrigenRaw) ? lugarOrigenRaw : 'legacy';

  return {
    id: Number(head.id),
    publicId: String(head.public_id ?? ''),
    entregaId: Number(head.entrega_id),
    esRemanente: Number(head.es_remanente) === 1,
    lugarId: Number(head.lugar_id),
    lugarOrigen,
    comunaId: Number(head.comuna_id),
    barrioId: Number(head.barrio_id),
    fechaHora: String(head.fecha_hora ?? ''),
    latitud: String(head.latitud ?? ''),
    longitud: String(head.longitud ?? ''),
    direccion: String(head.direccion ?? ''),
    responsableId: Number(head.responsable_id ?? 0),
    responsableNombre: String(head.responsable_nombre ?? ''),
    informePdf: publicFileUrl(head.informe_pdf, filesPublicPrefix),
    offlineUploadedAt,
    participantes,
  };
}
